import "@mux/mux-player/themes/microvideo";

import MuxPlayer from "@mux/mux-player-react/lazy";
import React from "react";
import { twJoin } from "tailwind-merge";

// Helpers _____________________________________________________________________________________________________________

const thumbnail = (id: string) => `https://image.mux.com/${id}/thumbnail.png?fit_mode=smartcrop&time=0`;

const FullPlayer: React.FC<{
  id: string;
  className?: string;
  theme?: "classic" | "microvideo";
}> = ({ id, className, theme }) => {
  return (
    <MuxPlayer
      playbackId={id}
      poster={thumbnail(id)}
      placeholder={thumbnail(id)}
      className={twJoin("fade-in", className)}
      style={{ aspectRatio: "16/9", minWidth: "100%", "--fullscreen-button": "none" } as React.CSSProperties}
      theme={theme}
      accentColor="rgb(49, 107, 171)"
      preload="auto"
      disableCookies={true}
    />
  );
};

const NoControls: React.FC<{
  id: string;
  className?: string;
  theme?: "classic" | "microvideo";
}> = ({ id, className, theme }) => {
  return (
    <MuxPlayer
      playbackId={id}
      poster={thumbnail(id)}
      placeholder={thumbnail(id)}
      className={twJoin("fade-in", className)}
      style={{ aspectRatio: "16/9", minWidth: "100%", "--controls": "none" } as React.CSSProperties}
      theme={theme}
      accentColor="rgb(49, 107, 171)"
      preload="auto"
      loop
      muted
      autoPlay="muted"
      disableCookies={true}
    />
  );
};

// Components __________________________________________________________________________________________________________

const Video: React.FC<{
  id: string;
  fullPlayer?: boolean;
  className?: string;
  classNameWrapper?: string;
  theme?: "classic" | "microvideo";
}> = ({ id, fullPlayer = false, className, classNameWrapper, theme = "microvideo" }) => {
  return (
    <div
      className={twJoin(
        "contents h-auto min-h-full w-full items-center justify-center overflow-hidden bg-black",
        classNameWrapper,
      )}
    >
      {fullPlayer ? (
        <FullPlayer id={id} className={className} theme={theme} />
      ) : (
        <NoControls id={id} className={className} theme={theme} />
      )}
    </div>
  );
};

export default Video;
